$(function () {
    /** Pour empiler les modals */
    document.querySelectorAll(".modal").forEach((e) => {
        e.addEventListener("shown.bs.modal", (ev) => {
            const nbModalsOpen = $(".modal.show").length;
            const target = $(ev.target);
            const zIndex = 1000 + 3 * nbModalsOpen;
            target.css("z-index", `${zIndex}`);

            let backdrop = $(".modal-backdrop:not([data-modal-stack])");

            if (backdrop.length === 0) {
                backdrop = $(`.modal-backdrop[data-modal-stack="${target[0].id}"]`);
            }

            backdrop.attr("style", `z-index: ${zIndex - 1}`);
            backdrop.attr("data-modal-stack", target[0].id);
        });
    });
});
